import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { Stack, xcss, Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import MinusIcon from '@atlaskit/icon/core/minus';

export const messages = defineMessages({
	freeColumnTitle: {
		id: 'experiment-aua-improve-conversion.free-edition-column.title',
		defaultMessage: 'Free',
		description:
			'Title of the free edition column in the free to standard feature comparison table.',
	},
});

export const FreeEditionColumn = () => {
	const { formatMessage } = useIntl();

	return (
		<Stack xcss={freeEditionColumnStyles} alignInline="center" space="space.200">
			<Stack alignInline="center">
				<Text size="medium" as="strong" color="color.text.subtlest">
					{formatMessage(messages.freeColumnTitle)}
				</Text>
			</Stack>
			<Stack space="space.200" xcss={iconContainerStyles}>
				<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<MinusIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<MinusIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<MinusIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<MinusIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<MinusIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
			</Stack>
		</Stack>
	);
};

const freeEditionColumnStyles = xcss({
	width: '90px',
	backgroundColor: 'color.background.input',
	paddingTop: 'space.100',
	paddingBottom: 'space.400',
	marginTop: 'space.050',
	height: '300px',
});

const iconContainerStyles = xcss({
	paddingTop: 'space.0',
});
